const map = {
	"./10/10c.png": 3706,
	"./10/10d.png": 8373,
	"./10/10h.png": 1513,
	"./10/10s.png": 4682,
	"./2/2c.png": 5486,
	"./2/2d.png": 49,
	"./2/2h.png": 3037,
	"./2/2s.png": 5070,
	"./3/3c.png": 6758,
	"./3/3d.png": 6729,
	"./3/3h.png": 7701,
	"./3/3s.png": 3846,
	"./4/4c.png": 3586,
	"./4/4d.png": 7837,
	"./4/4h.png": 5473,
	"./4/4s.png": 370,
	"./5/5c.png": 4474,
	"./5/5d.png": 8773,
	"./5/5h.png": 1913,
	"./5/5s.png": 1290,
	"./6/6c.png": 3982,
	"./6/6d.png": 4993,
	"./6/6h.png": 8333,
	"./6/6s.png": 6718,
	"./7/7c.png": 486,
	"./7/7d.png": 457,
	"./7/7h.png": 5077,
	"./7/7s.png": 1222,
	"./8/8c.png": 1210,
	"./8/8d.png": 1637,
	"./8/8h.png": 3193,
	"./8/8s.png": 7946,
	"./9/9c.png": 5330,
	"./9/9d.png": 5309,
	"./9/9h.png": 2321,
	"./9/9s.png": 8898,
	"./A/Ac.png": 1074,
	"./A/Ad.png": 2637,
	"./A/Ah.png": 3441,
	"./A/As.png": 4290,
	"./J/Jc.png": 1678,
	"./J/Jd.png": 9393,
	"./J/Jh.png": 5405,
	"./J/Js.png": 4190,
	"./K/Kc.png": 3894,
	"./K/Kd.png": 3865,
	"./K/Kh.png": 4837,
	"./K/Ks.png": 982,
	"./Q/Qc.png": 9458,
	"./Q/Qd.png": 1021,
	"./Q/Qh.png": 1825,
	"./Q/Qs.png": 2674,
	"./Reverse/Reverse1.webp": 9869
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9086;